<template>
  <el-dialog
    title="报名信息"
    :visible.sync="visible"
    :before-close="handleClose"
    width="80%"
    top="2vh"
  >
    <div class="content">
      <div class="info">
        <div class="info-title">修改前信息</div>
        <div class="course">
          <div class="course_name">
            班级名称：
            <b>{{ params.row.albumTitle }}</b>
          </div>
          <div class="course_profession">
            班级所属专业：
            <b style="cursor: pointer">{{ params.row.majorName }}</b>
          </div>
        </div>
        <el-form
          ref="checkForm"
          :rules="checkFormRules"
          :model="checkForm"
          label-width="150px"
        >
          <el-form-item label="姓名：">{{
            zkolApplyUserAuth.name || ''
          }}</el-form-item>
          <el-form-item label="准考证号：">{{
            zkolApplyUserAuth.examNumber || ''
          }}</el-form-item>
          <el-form-item label="身份证号：">{{
            zkolApplyUserAuth.idCard || ''
          }}</el-form-item>
          <el-form-item label="手机号：">{{
            zkolApplyUserAuth.phone || ''
          }}</el-form-item>
          <el-form-item label="微信号：">{{
            zkolApplyUserAuth.wechat || ''
          }}</el-form-item>
          <el-form-item label="邮箱：">{{
            zkolApplyUserAuth.email || ''
          }}</el-form-item>
          <el-form-item label="考生来源：">
            <span v-if="zkolApplyUserAuth.stuSource == '1'">社会生</span>
            <span v-if="zkolApplyUserAuth.stuSource == '2'">助学机构</span>
            <span v-if="zkolApplyUserAuth.stuSource == '3'"
              >公开学院,高职相沟通,本科二学历</span
            >
          </el-form-item>
          <el-form-item label="层次：">
            <span v-if="zkolApplyUserAuth.level == '1'">本科</span>
            <span v-if="zkolApplyUserAuth.level == '2'">专科</span>
          </el-form-item>
          <el-form-item label="是否申请学士学位：">
            <span v-if="zkolApplyUserAuth.degreeStatus == '1'">是</span>
            <span v-if="zkolApplyUserAuth.degreeStatus == '2'">否</span>
          </el-form-item>

          <el-form-item label="本人所在专业：">{{
            zkolApplyUserAuth.professionName || ''
          }}</el-form-item>
          <el-form-item
            v-if="params.row.majorName != zkolApplyUserAuth.professionName"
            class="registration_tips"
            label="审核提示："
          >
            该学员报名课程所属专业与本人所在专业不符！
          </el-form-item>
          <el-form-item label="审核状态：" prop="status">
            <el-radio-group
              v-model="checkForm.status"
              @change="handleStatusChange"
            >
              <el-radio label="1">审核通过</el-radio>
              <el-radio label="4">审核退回</el-radio>
              <el-radio label="0">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="notPass"
            :label="
              checkForm.status === '0' ? '审核未通过意见：' : '退回意见：'
            "
            prop="noPassReason"
          >
            <el-input
              type="textarea"
              resize="none"
              :rows="3"
              v-model="checkForm.noPassReason"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="info">
        <div class="info-title">修改后信息</div>
        <el-form :model="form" :rules="rules" ref="form" label-width="150px">
          <el-row justify="center">
            <el-col>
              <el-form-item label="姓名：" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="准考证号：" prop="examNumber">
                <el-input
                  v-model="form.examNumber"
                  maxlength="12"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="身份证号：" prop="idCard">
                <el-input
                  v-model="form.idCard"
                  placeholder="请输入"
                  clearable
                  maxlength="18"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="手机号：" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="微信号：" prop="wechat">
                <el-input
                  v-model="form.wechat"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="邮箱：" prop="email">
                <el-input
                  v-model="form.email"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="考生来源：" prop="stuSource">
                <el-select
                  v-model="form.stuSource"
                  placeholder="请选择"
                  clearable
                  filterable
                  @change="handleChangeStuSource"
                >
                  <el-option
                    v-for="item in stuSourceList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="层次：" prop="level">
                <el-select
                  v-model="form.level"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in levelList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="是否申请学士学位：" prop="degreeStatus">
                <el-select
                  v-model="form.degreeStatus"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in degreeStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="本人所在专业：" prop="profession">
                <el-select
                  v-model="form.profession"
                  placeholder="请选择"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in categoryList"
                    :key="item.zyCurrencyCategoryId"
                    :label="item.title"
                    :value="item.zyCurrencyCategoryId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as api from '@/api/index'
import * as api2 from '@/api/ClassRegistManagement/index.js'
import * as api3 from '@/api/courseware/coursewareList'
export default {
  components: {},
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  data() {
    const validateExamNumber = (rule, value, callback) => {
      if (value.length < 12) {
        callback(new Error('准考证号格式不正确'))
      }
      callback()
    }
    const validateIdCard = (rule, value, callback) => {
      let validate = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (!validate.test(value)) {
        callback(new Error('请输入合法的身份证号码'))
      }
      callback()
    }
    const validatePhone = (rule, value, callback) => {
      const validate = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
      if (!validate.test(value)) {
        callback(new Error('请输入合法的手机号'))
      }
      callback()
    }
    const validateEmail = (rule, value, callback) => {
      const validate = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (!validate.test(value)) {
        callback(new Error('请输入正确的邮箱号码'))
      }
      callback()
    }
    return {
      visible: true,
      uName: '', //审核人姓名
      // 查看时展示的数据
      zkolApplyUserAuth: {},
      checkFormRules: {
        noPassReason: [
          {
            required: this.notPass,
            message: '请输入未通过意见',
            trigger: 'blur',
          },
        ],
      },
      notPass: false,
      // 考生来源列表
      stuSourceList: [
        { label: '社会考生', value: '1' },
        { label: '社会助学机构学员', value: '2' },
        { label: '公开学院、高职相沟通、本科二学历学员', value: '3' },
      ],
      showOrganization: false,
      formShowOrganization: false,
      checkForm: {
        status: '1',
        noPassReason: '',
      },
      levelList: [
        { label: '本科', value: '1' },
        { label: '专科', value: '2' },
      ],
      degreeStatusList: [
        { label: '是', value: '1' },
        { label: '否', value: '2' },
      ],
      professionList: [],
      // 需提交的数据
      form: {
        id: '',
        uid: '',
        name: '',
        examNumber: '',
        idCard: '',
        phone: '',
        wechat: '',
        email: '',
        stuSource: '',
        organization: '',
        level: '',
        degreeStatus: '',
        infoType: '',
        orderId: '',
        profession: '',
      },
      rules: {
        examNumber: [{ validator: validateExamNumber, trigger: 'blur' }],
        idCard: [{ validator: validateIdCard, trigger: 'blur' }],
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        email: [{ validator: validateEmail, trigger: 'blur' }],
      },
      // 非待审核
      isWaitRemark: false,
      isPreviewStudentProfile: false,
      isShowCourseRelationProfession: false,
      textarea: '',
      isDifferentProfession: false,
      categoryList: [],

      verifyMode: '', //报名方式
      batchId: '',
    }
  },
  created() {
    this.getUserByUid()
  },
  methods: {
    getUserByUid() {
      api3.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.uName = data.data.uname
        }
      })
    },
    // 获取专业
    async getCategoryList() {
      let { data } = (await api.getAllCategory()).data
      this.categoryList = data
      this.getRegistUserInfo()
    },

    // 处理弹窗关闭事件
    handleClose() {
      if (!this.isWaitRemark) {
        this.$refs.form.resetFields()
      }
      this.$emit('closeClassRegistAudit')
    },
    // 提交
    submitForm() {
      this.$refs.checkForm.validate(async (valid) => {
        if (valid) {
          const obj = {
            zkolApplyUserAuth: this.form,
            orderId: this.params.row.orderId,
            courseId: this.params.row.albumId,
            type: this.params.row.infoType,
          }
          const { noPassReason, status } = this.checkForm
          console.log(status, 'status')
          let isSuccess = true
          const updateUserInfoRes = await api.updateUserInfo(obj)
          if (updateUserInfoRes.data.code !== 100000) {
            isSuccess = false
            return this.$message.error(updateUserInfoRes.data.msg || '提交失败')
          }
          const updateApproveStatusRes = await api.updateApproveStatus({
            noPassReason,
            ids: this.params.row.orderId,
            infoType: this.params.row.infoType,
            verifyStatus: status,
            uid: this.getUId,
            sIds: this.form.uid,
            uName: this.uName,
          })
          if (updateApproveStatusRes.data.code !== 100000) {
            isSuccess = false
            return this.$message.error(
              updateApproveStatusRes.data.msg || '提交失败'
            )
          }
          if (status == 0 && this.verifyMode == 1) {
            const doRefundRes = await api.doRefund({
              ids: this.params.row.orderId,
              infoType: this.params.row.infoType,
              sIds: this.form.uid,
              uid: this.getUId,
              uName: this.uName,
              noPassReason,
            })
            if (doRefundRes.data.code !== 100000) {
              isSuccess = false
              this.$message({
                type: 'error',
                message: doRefundRes.data.msg || '提交失败',
              })
            }
          }
          if (isSuccess) {
            this.handleClose('success')
            this.$message({ type: 'success', message: '提交成功' })
          }
        }
      })
    },

    // 监听状态改变
    handleStatusChange(val) {
      this.$nextTick(() => {
        this.$refs['checkForm'].clearValidate(['noPassReason'])
        const notPass = val === '0' || val === '4'
        this.notPass = this.checkFormRules.noPassReason[0].required = notPass
        if (val === '0') {
          this.checkFormRules.noPassReason[0].message = '请输入未通过意见'
        } else if (val === '4') {
          this.checkFormRules.noPassReason[0].message = '请输入退回意见'
        }
      })
    },

    // 监听考生来源改变
    handleChangeStuSource(val) {
      this.formShowOrganization = val === '2'
    },
    showCourseRelationProfession(majorName) {
      this.textarea = majorName
      this.isShowCourseRelationProfession = true
    },
    closeCourseRelationProfession() {
      this.isShowCourseRelationProfession = false
    },
    async getRegistUserInfo() {
      const { code, data } = (
        await api2.getRegistUserInfo({
          courseId: this.params.row.albumId,
          uid: this.params.row.uid,
          type: this.params.row.infoType,
        })
      ).data
      if (code === 100000) {
        this.form = { ...data }
        const item  = this.categoryList.find(v => v.zyCurrencyCategoryId == this.form.profession)
        if(item){
          this.form.professionName =  item.title
        }else{
          this.form.professionName =  ''
        }
        // let professionName = ''
        // this.categoryList.forEach((item) => {
        //   if (item.zyCurrencyCategoryId == this.form.profession) {
        //     professionName = item.title
        //     return
        //   }
        // })
        // this.form.profession = this.form.profession
        //   ? parseInt(this.form.profession)
        //   : ''
        // console.log(' this.form', this.form, professionName)
        this.form.profession = Number(this.form.profession)
        this.zkolApplyUserAuth = this.form
        // this.zkolApplyUserAuth.professionName = professionName
      }
    },
  },
  watch: {
    params: {
      immediate: true,
      handler: function (value) {
        console.log(66, this.params)
        if (value && value.status) {
          this.status = value.status
          this.getCategoryList()
         
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .course {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    b {
      color: #000;
    }
  }
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
  /deep/ .registration_tips {
    font-weight: 700;
    color: rgb(217, 0, 27);
    .el-form-item__label {
      color: rgb(217, 0, 27);
    }
  }
}
</style>
